__turbopack_context__.v({
  "featuredBlogsTitle": "d5Sssq_featuredBlogsTitle",
});
